@import "@stylesheets/variables";
@import "@stylesheets/profile-edit-button.scss";

$mobile: 480px;
$tablet: 481px;
$desktop: 768px;

@mixin breakpoint($point) {
  @if $point == mobile {
    @media (max-width: $mobile) {
      @content;
    }
  }

  @else if $point == tablet {
    @media (min-width: $tablet) {
      @content;
    }
  }

  @else if $point == desktop {
    @media (min-width: $desktop) {
      @content;
    }
  }
}

#title-modal {
  .modal-container {
    height: fit-content;
    margin: 16px;
    width: unset;
  }

  .modal-content {
    padding: 16px 16px 32px 16px;
    max-width: unset;
    min-width: unset;

    @include breakpoint(desktop) {
      margin-left: auto;
      margin-right: auto;
    }
  }

  .close-bar {
    display: flex;
    justify-content: flex-end;
    height: 24px;

    button {
      background: transparent;
      position: absolute;
    }
  }

  .title-service-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 24px;
    margin-left: auto;
    margin-right: auto;
    max-width: 500px;

    @include breakpoint(tablet) {
      margin-right: 57px;
      margin-left: 57px;
    }

    &.completed {
      align-items: center;
      max-width: 381px;

      .button-container {
        flex-direction: column;

        button {
          min-width: 203px;
        }
      }

      @include breakpoint(tablet) {
        margin-right: 32px;
        margin-left: 32px;
      }
    }

    .phone-input .small-bold-font {
      color: $gray-400 !important;
    }

    .react-tel-input {
      height: 48px;
    }

    .title-thank-you {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .button-container {
      display: flex;
      justify-content: center;
      gap: 8px;
      flex-direction: column-reverse;

      @include breakpoint(desktop) {
        flex-direction: row;
      }

      .profile-edit-button {
        display: flex;
        height: 48px;

        @include breakpoint(desktop) {
          width: 200px;
        }
      }
    }

    .divider {
      border-top: 1px solid $gray-200;
      width: 100%;
    }
  }

  .form-control {
    width: 100%;
    height: 100%;
    padding: 8px 8px 8px 58px;
    border-color: $gray-300;

    &:focus {
      border-color: $medium-green;
      box-shadow: 0 0 0 1px $medium-green;
    }

    &.invalid-number {
      border: 1px solid #f44336 !important;

      &:focus {
        border-color: unset;
        box-shadow: unset;
      }
    }
  }
}
